import { Box, Typography } from '@mui/material';
import { FloatScanButton } from 'components';
import { useTranslation } from 'react-i18next';
import { MotionWrapper } from 'utils';
import './index.css';

const FAQ = () => {
	const { t } = useTranslation();

	return (
		<MotionWrapper>
			<Box sx={{ overflow: 'scroll' }} pb={6}>
				<Typography className="FAQ FAQ-Q">{t('FAQ.Q1')}</Typography>
				<Typography className="FAQ FAQ-A">{t('FAQ.A1')}</Typography>
				<Typography className="FAQ FAQ-Q">{t('FAQ.Q2')}</Typography>
				<Typography className="FAQ FAQ-A">{t('FAQ.A2')}</Typography>
				<Typography className="FAQ FAQ-Q">{t('FAQ.Q3')}</Typography>
				<Typography className="FAQ FAQ-A">{t('FAQ.A3')}</Typography>
				<Typography className="FAQ FAQ-Q">{t('FAQ.Q4')}</Typography>
				<Typography className="FAQ FAQ-A">{t('FAQ.A4')}</Typography>
			</Box>
			<FloatScanButton />
		</MotionWrapper>
	);
};

export default FAQ;
